<template>
  <Modal>
    <h1 slot="header">Edit Application Submitted on {{ submissionDate }}</h1>
    <EditModalBody
      slot="body"
      :application="application"
      :onValueChanged="onValueChanged"
      :addAdditionalSectionThree="addAdditionalSectionThree"
      :removeSectionThree="removeSectionThree"
      :addAdditionalSectionFour="addAdditionalSectionFour"
      :removeSectionFour="removeSectionFour"
      :allowImages="false"
      :emailDisclaimerShown="true"
      :showEmailDisclaimer="showEmailDisclaimer"
      :error="canSaveSelectedApplication ? false : 'Missing Information!'"
    />
    <EditModalFooter
      slot="footer"
      :canSaveSelectedApplication="canSaveSelectedApplication"
      :updateApplication="updateApplication"
      :cancelEditing="cancelEditing"
    />
  </Modal>
</template>

<script>
import EditModalBody from "@/components/Speaker/EditModalBody";
import EditModalFooter from "@/components/Speaker/EditModalFooter";
import Modal from "@/components/Modal";
import { Application } from "@/typings/application";

export default {
  components: {
    EditModalBody,
    EditModalFooter,
    Modal
  },
  props: {
    application: {
      type: Application,
      required: true,
      default: () => {
        return new Application();
      }
    },
    onValueChanged: {
      type: Function,
      required: true,
      default: () => {}
    },
    addAdditionalSectionThree: {
      type: Function,
      required: true,
      default: () => {}
    },
    removeSectionThree: {
      type: Function,
      required: true,
      default: () => {}
    },
    addAdditionalSectionFour: {
      type: Function,
      required: true,
      default: () => {}
    },
    removeSectionFour: {
      type: Function,
      required: true,
      default: () => {}
    },
    showEmailDisclaimer: {
      type: Function,
      required: true,
      default: () => {}
    },
    canSaveSelectedApplication: {
      type: Boolean,
      required: true,
      default: () => {
        return false;
      }
    },
    updateApplication: {
      type: Function,
      required: true,
      default: () => {}
    },
    cancelEditing: {
      type: Function,
      required: true,
      default: () => {}
    },
    submissionDate: {
      type: String,
      required: true,
      default: () => {
        return "";
      }
    }
  }
};
</script>
